import React from 'react'
import formatNumber from '@arsenal/arsenal/modules/formatNumber'
import formatTime from 'lib/format-time'

interface IProps {
  playNums: number
  publishTime: number
  postUnit?: string
  className?: string
}

const VideoStats: React.FC<IProps> = ({
  playNums,
  publishTime,
  postUnit = '次阅读',
  className = '',
}) => {
  const publishTimeStr = publishTime

  return (
    <div style={{ marginTop: 8 }} className={className}>
      <span className="play-nums text">
        {formatNumber(playNums)}
        {postUnit}
      </span>
      <span className="publish-time text">
        {formatTime(publishTime * 1000)}
      </span>
      <style jsx>
        {`
          .text {
            font-size: 14px;
            color: #606370;
          }
          .publish-time {
            margin-left: 8px;
          }
        `}
      </style>
    </div>
  )
}

export default VideoStats
